import React from "react";
import { Tag, Tooltip } from "antd";
import { getDocTypeInfo, truncateTitle, buildDownloadUrl } from "./GradeHelpers";

export default function DocTag({ doc, onPreview }) {
    const { kind, icon } = getDocTypeInfo(doc);
    const title = doc.title || "";
    const displayTitle = truncateTitle(title);
    const href = doc.uri;

    if (kind === "empty") {
        return (
            <Tooltip title={title || "暂无"}>
                <Tag icon={icon} style={{ cursor: "default", color: "#ccc" }}>
                    {displayTitle || "暂无"}
                </Tag>
            </Tooltip>
        );
    }

    const handleClick = (e) => {
        e.preventDefault();
        if (kind === "image" && onPreview) {
            onPreview(href);
        } else {
            const url = buildDownloadUrl(href, title);
            window.open(url, "_blank");
        }
    };

    return (
        <Tooltip title={title}>
            <Tag
                icon={icon}
                color="blue"
                style={{ cursor: "pointer" }}
                onClick={handleClick}
            >
                {displayTitle}
            </Tag>
        </Tooltip>
    );
}
